export interface ComicChapter {
  id: string;
  title: string;
  updateDate: string;
  number: number;
}

export interface ComicItem {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  description: string;
  rating: number;
  views: number;
  chapters: ComicChapter[];
  tags: string[];
  updateDate: string;
  status: '连载中' | '已完结';
  featured: boolean;
  hotRank: number;
}

export interface ComicCategory {
  slug: string;
  name: string;
  count: number;
}

export const categories: ComicCategory[] = [
  { slug: 'all', name: '全部', count: 86 },
  { slug: 'romance', name: '恋爱', count: 24 },
  { slug: 'fantasy', name: '奇幻', count: 18 },
  { slug: 'action', name: '动作', count: 15 },
  { slug: 'mystery', name: '悬疑', count: 10 },
  { slug: 'slice-of-life', name: '日常', count: 8 },
  { slug: 'bl', name: '耽美', count: 6 },
  { slug: 'comedy', name: '搞笑', count: 5 },
];

export const comics: ComicItem[] = [
  {
    id: 'comic-1',
    title: '我的野蛮女友',
    author: '金浩植',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20comic%20cover%20art%20style%2C%20young%20couple%20in%20Seoul%20city%20street%2C%20warm%20sunset%20lighting%2C%20elegant%20digital%20illustration%2C%20soft%20romantic%20atmosphere%2C%20clean%20composition%20with%20simple%20background&width=600&height=800&seq=hanman-cover-01&orientation=portrait',
    category: 'romance',
    description: '讲述了一个普通大学生与一个性格强势的女孩之间既搞笑又感人的爱情故事。两人的相遇改变了彼此的人生轨迹，从最初的互相嫌弃到逐渐了解，最终坠入爱河。这部作品以其真实细腻的情感描写和幽默的叙事风格，成为了韩国浪漫喜剧漫画的经典之作，深受读者喜爱。',
    rating: 4.8,
    views: 1285000,
    chapters: [
      { id: 'ch-1-1', title: '第1话 命运的相遇', updateDate: '2026-08-01', number: 1 },
      { id: 'ch-1-2', title: '第2话 第一次约会', updateDate: '2026-07-28', number: 2 },
      { id: 'ch-1-3', title: '第3话 误会', updateDate: '2026-07-25', number: 3 },
      { id: 'ch-1-4', title: '第4话 和解', updateDate: '2026-07-22', number: 4 },
      { id: 'ch-1-5', title: '第5话 告白', updateDate: '2026-07-19', number: 5 },
      { id: 'ch-1-6', title: '第6话 新的开始', updateDate: '2026-07-16', number: 6 },
      { id: 'ch-1-7', title: '第7话 挑战', updateDate: '2026-07-13', number: 7 },
      { id: 'ch-1-8', title: '第8话 彼此的承诺', updateDate: '2026-07-10', number: 8 },
    ],
    tags: ['恋爱', '喜剧', '校园', '日常'],
    updateDate: '2026-08-01',
    status: '连载中',
    featured: true,
    hotRank: 1,
  },
  {
    id: 'comic-2',
    title: '剑与魔法之王国',
    author: '李泰俊',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20comic%20cover%2C%20warrior%20with%20sword%20in%20magical%20kingdom%2C%20epic%20adventure%20illustration%2C%20dramatic%20lighting%2C%20detailed%20digital%20art%2C%20golden%20and%20crimson%20color%20palette%2C%20clean%20simple%20background&width=600&height=800&seq=hanman-cover-02&orientation=portrait',
    category: 'fantasy',
    description: '在一个被魔法与剑统治的世界里，年轻的剑士艾伦踏上了拯救王国的冒险旅程。他必须面对强大的黑暗势力，集结志同道合的伙伴，揭开古老的预言。华丽的魔法战斗场面与深刻的人物塑造，让这部奇幻冒险漫画成为不可错过的佳作。',
    rating: 4.7,
    views: 986000,
    chapters: [
      { id: 'ch-2-1', title: '第1话 觉醒', updateDate: '2026-08-02', number: 1 },
      { id: 'ch-2-2', title: '第2话 踏上旅途', updateDate: '2026-07-30', number: 2 },
      { id: 'ch-2-3', title: '第3话 龙之谷', updateDate: '2026-07-27', number: 3 },
      { id: 'ch-2-4', title: '第4话 远古遗迹', updateDate: '2026-07-24', number: 4 },
      { id: 'ch-2-5', title: '第5话 暗影来袭', updateDate: '2026-07-21', number: 5 },
      { id: 'ch-2-6', title: '第6话 光明之力', updateDate: '2026-07-18', number: 6 },
    ],
    tags: ['奇幻', '冒险', '魔法', '战斗'],
    updateDate: '2026-08-02',
    status: '连载中',
    featured: true,
    hotRank: 2,
  },
  {
    id: 'comic-3',
    title: '都市猎人之暗夜追踪',
    author: '朴志勋',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20thriller%20cover%2C%20mysterious%20detective%20in%20dark%20city%20alleyway%2C%20noir%20style%20digital%20illustration%2C%20rainy%20night%20atmosphere%2C%20dramatic%20shadows%2C%20cinematic%20composition%2C%20clean%20simple%20background&width=600&height=800&seq=hanman-cover-03&orientation=portrait',
    category: 'action',
    description: '首尔的夜晚，罪恶在暗处滋生。前特种部队成员姜宇成为了都市传说中的"猎人"，专门追踪那些逃脱法律制裁的罪犯。每一话都充满紧张刺激的动作场面和扣人心弦的悬疑情节，带你进入一个不为人知的地下世界。',
    rating: 4.6,
    views: 845000,
    chapters: [
      { id: 'ch-3-1', title: '第1话 猎人之夜', updateDate: '2026-08-03', number: 1 },
      { id: 'ch-3-2', title: '第2话 第一个目标', updateDate: '2026-07-31', number: 2 },
      { id: 'ch-3-3', title: '第3话 追捕', updateDate: '2026-07-28', number: 3 },
      { id: 'ch-3-4', title: '第4话 迷宫', updateDate: '2026-07-25', number: 4 },
      { id: 'ch-3-5', title: '第5话 真相浮现', updateDate: '2026-07-22', number: 5 },
    ],
    tags: ['动作', '悬疑', '犯罪', '都市'],
    updateDate: '2026-08-03',
    status: '连载中',
    featured: true,
    hotRank: 3,
  },
  {
    id: 'comic-4',
    title: '第七个秘密',
    author: '崔恩熙',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20thriller%20cover%2C%20woman%20looking%20through%20old%20photographs%2C%20mysterious%20atmosphere%2C%20psychological%20suspense%2C%20dark%20and%20moody%20digital%20illustration%2C%20cool%20tone%20colors%2C%20clean%20simple%20background&width=600&height=800&seq=hanman-cover-04&orientation=portrait',
    category: 'mystery',
    description: '在一个偏远的山村，七个孩子神秘失踪。十年后，一位年轻的记者发现了隐藏在背后的惊天秘密。随着调查的深入，她发现自己也陷入了危险的漩涡之中。这部悬疑漫画以其精巧的叙事结构和出人意料的剧情反转，让读者欲罢不能。',
    rating: 4.9,
    views: 756000,
    chapters: [
      { id: 'ch-4-1', title: '第1话 失踪', updateDate: '2026-07-29', number: 1 },
      { id: 'ch-4-2', title: '第2话 线索', updateDate: '2026-07-26', number: 2 },
      { id: 'ch-4-3', title: '第3话 证人', updateDate: '2026-07-23', number: 3 },
      { id: 'ch-4-4', title: '第4话 深渊', updateDate: '2026-07-20', number: 4 },
      { id: 'ch-4-5', title: '第5话 第七个孩子', updateDate: '2026-07-17', number: 5 },
      { id: 'ch-4-6', title: '第6话 真相', updateDate: '2026-07-14', number: 6 },
      { id: 'ch-4-7', title: '第7话 终章', updateDate: '2026-07-11', number: 7 },
    ],
    tags: ['悬疑', '惊悚', '推理', '剧情'],
    updateDate: '2026-07-29',
    status: '已完结',
    featured: false,
    hotRank: 4,
  },
  {
    id: 'comic-5',
    title: '咖啡馆的四季',
    author: '尹素拉',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%2C%20cozy%20cafe%20interior%20with%20warm%20lighting%2C%20barista%20making%20coffee%2C%20gentle%20everyday%20scene%2C%20soft%20pastel%20color%20palette%2C%20healing%20atmosphere%2C%20clean%20simple%20composition&width=600&height=800&seq=hanman-cover-05&orientation=portrait',
    category: 'slice-of-life',
    description: '在首尔一条安静的巷子里，有一家名为"四季"的小咖啡馆。四位性格迥异的年轻人在这里相遇，分享彼此的故事与人生。温暖的日常、美味的咖啡、真挚的友谊——这是一部让你在忙碌生活中找到片刻宁静的治愈系漫画。',
    rating: 4.5,
    views: 623000,
    chapters: [
      { id: 'ch-5-1', title: '第1话 春天的拿铁', updateDate: '2026-07-20', number: 1 },
      { id: 'ch-5-2', title: '第2话 夏日的冰美式', updateDate: '2026-07-17', number: 2 },
      { id: 'ch-5-3', title: '第3话 秋天的摩卡', updateDate: '2026-07-14', number: 3 },
      { id: 'ch-5-4', title: '第4话 冬日的热可可', updateDate: '2026-07-11', number: 4 },
    ],
    tags: ['日常', '治愈', '美食', '友情'],
    updateDate: '2026-07-20',
    status: '连载中',
    featured: false,
    hotRank: 5,
  },
  {
    id: 'comic-6',
    title: '星光下的约定',
    author: '韩智敏',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20romance%20cover%2C%20two%20young%20men%20under%20starry%20night%20sky%2C%20gentle%20romantic%20atmosphere%2C%20soft%20blue%20and%20pink%20color%20palette%2C%20beautiful%20digital%20illustration%2C%20emotional%20composition%2C%20clean%20simple%20background&width=600&height=800&seq=hanman-cover-06&orientation=portrait',
    category: 'bl',
    description: '两个少年在高中时因一场误会而疏远，多年后在星空下重逢。过去的伤痛能否被治愈？他们能否重新找回失去的友谊——或者更多的情感？这是一部细腻描绘青春情感的作品，以唯美的画风和真挚的情感打动人心。',
    rating: 4.7,
    views: 892000,
    chapters: [
      { id: 'ch-6-1', title: '第1话 久别重逢', updateDate: '2026-08-04', number: 1 },
      { id: 'ch-6-2', title: '第2话 回忆的碎片', updateDate: '2026-08-01', number: 2 },
      { id: 'ch-6-3', title: '第3话 心动的瞬间', updateDate: '2026-07-29', number: 3 },
      { id: 'ch-6-4', title: '第4话 勇敢的一步', updateDate: '2026-07-26', number: 4 },
      { id: 'ch-6-5', title: '第5话 星光之下', updateDate: '2026-07-23', number: 5 },
    ],
    tags: ['耽美', '恋爱', '校园', '青春'],
    updateDate: '2026-08-04',
    status: '连载中',
    featured: false,
    hotRank: 6,
  },
  {
    id: 'comic-7',
    title: '异世界便利店',
    author: '郑太雄',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20fantasy%20cover%2C%20convenience%20store%20in%20fantasy%20world%2C%20funny%20characters%2C%20colorful%20cheerful%20digital%20illustration%2C%20bright%20lighting%2C%20humorous%20composition%2C%20clean%20simple%20background&width=600&height=800&seq=hanman-cover-07&orientation=portrait',
    category: 'comedy',
    description: '普通上班族李明秀一觉醒来，发现自己穿越到了一个剑与魔法的异世界——但他没有获得任何超能力，只在背包里发现了一家便利店的钥匙。于是，异世界第一家便利店开张了！泡面、三角饭团、香蕉牛奶……这些平凡的现代商品在异世界引发了怎样的风波？搞笑又治愈的穿越喜剧。',
    rating: 4.4,
    views: 534000,
    chapters: [
      { id: 'ch-7-1', title: '第1话 穿越第一天', updateDate: '2026-07-15', number: 1 },
      { id: 'ch-7-2', title: '第2话 第一位客人', updateDate: '2026-07-12', number: 2 },
      { id: 'ch-7-3', title: '第3话 泡面革命', updateDate: '2026-07-09', number: 3 },
    ],
    tags: ['搞笑', '穿越', '奇幻', '日常'],
    updateDate: '2026-07-15',
    status: '连载中',
    featured: false,
    hotRank: 7,
  },
  {
    id: 'comic-8',
    title: '皇后的逆袭',
    author: '姜美莱',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20romance%20cover%2C%20queen%20in%20traditional%20Korean%20hanbok%2C%20royal%20palace%20setting%2C%20elegant%20digital%20illustration%2C%20golden%20and%20red%20color%20scheme%2C%20dramatic%20composition%2C%20clean%20simple%20background&width=600&height=800&seq=hanman-cover-08&orientation=portrait',
    category: 'romance',
    description: '被陷害而打入冷宫的皇后李妍，在绝望之际获得了重生的机会。回到过去，这一次她不再是任人宰割的弱女子。利用前世的记忆，她步步为营，在复杂的宫廷斗争中夺回属于自己的一切。而那位冷峻的帝王，似乎也并非表面那般无情……',
    rating: 4.8,
    views: 1102000,
    chapters: [
      { id: 'ch-8-1', title: '第1话 重生', updateDate: '2026-08-03', number: 1 },
      { id: 'ch-8-2', title: '第2话 复仇之始', updateDate: '2026-07-31', number: 2 },
      { id: 'ch-8-3', title: '第3话 棋局', updateDate: '2026-07-28', number: 3 },
      { id: 'ch-8-4', title: '第4话 帝王的秘密', updateDate: '2026-07-25', number: 4 },
      { id: 'ch-8-5', title: '第5话 联手', updateDate: '2026-07-22', number: 5 },
      { id: 'ch-8-6', title: '第6话 逆转', updateDate: '2026-07-19', number: 6 },
    ],
    tags: ['恋爱', '宫廷', '重生', '复仇'],
    updateDate: '2026-08-03',
    status: '连载中',
    featured: true,
    hotRank: 8,
  },
  {
    id: 'comic-9',
    title: '暗黑破坏神之陨落',
    author: '宋元锡',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20dark%20fantasy%20action%20cover%2C%20demon%20slayer%20with%20dark%20armor%2C%20apocalyptic%20battlefield%2C%20intense%20dramatic%20digital%20illustration%2C%20fire%20and%20shadow%2C%20epic%20scale%2C%20clean%20simple%20background&width=600&height=800&seq=hanman-cover-09&orientation=portrait',
    category: 'action',
    description: '天界与魔界的战争持续了千年。当人类世界被卷入这场浩劫，一位被放逐的半神之子成为了最后的希望。宏大的世界观、震撼的战斗场面和深刻的人性探讨，让这部动作漫画成为了现象级作品。',
    rating: 4.6,
    views: 678000,
    chapters: [
      { id: 'ch-9-1', title: '第1话 陨落之日', updateDate: '2026-07-18', number: 1 },
      { id: 'ch-9-2', title: '第2话 灰烬中崛起', updateDate: '2026-07-15', number: 2 },
      { id: 'ch-9-3', title: '第3话 远古盟约', updateDate: '2026-07-12', number: 3 },
      { id: 'ch-9-4', title: '第4话 试炼之路', updateDate: '2026-07-09', number: 4 },
    ],
    tags: ['动作', '奇幻', '战斗', '史诗'],
    updateDate: '2026-07-18',
    status: '连载中',
    featured: false,
    hotRank: 9,
  },
  {
    id: 'comic-10',
    title: '她来自2046',
    author: '金秀雅',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sci-fi%20romance%20cover%2C%20futuristic%20cityscape%20with%20neon%20lights%2C%20time%20traveler%20woman%2C%20cyberpunk%20aesthetic%2C%20cool%20tone%20digital%20illustration%2C%20romantic%20sci-fi%20atmosphere%2C%20clean%20simple%20background&width=600&height=800&seq=hanman-cover-10&orientation=portrait',
    category: 'fantasy',
    description: '2046年，人类发明了时间旅行技术。研究员韩素希被派往2026年执行一项秘密任务，却意外与一个普通大学生产生了感情纠葛。当未来与现在交织，爱情能否跨越时间的鸿沟？这部科幻恋爱漫画融合了悬疑、浪漫和深刻的人性思考。',
    rating: 4.5,
    views: 512000,
    chapters: [
      { id: 'ch-10-1', title: '第1话 时空裂缝', updateDate: '2026-07-10', number: 1 },
      { id: 'ch-10-2', title: '第2话 错误的相遇', updateDate: '2026-07-07', number: 2 },
      { id: 'ch-10-3', title: '第3话 蝴蝶效应', updateDate: '2026-07-04', number: 3 },
    ],
    tags: ['奇幻', '科幻', '恋爱', '穿越'],
    updateDate: '2026-07-10',
    status: '连载中',
    featured: false,
    hotRank: 10,
  },
  {
    id: 'comic-11',
    title: '甜蜜的陷阱',
    author: '刘智媛',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20comedy%20cover%2C%20couple%20in%20bakery%20shop%2C%20sweet%20pastel%20color%20palette%2C%20cute%20digital%20illustration%2C%20warm%20lighting%2C%20romantic%20comedy%20vibe%2C%20clean%20simple%20background&width=600&height=800&seq=hanman-cover-11&orientation=portrait',
    category: 'romance',
    description: '甜品师林秀晶开了一家小小的甜品店，没想到对面搬来了一位冷面米其林大厨。两人从竞争到合作，从互怼到心动——这场围绕着甜品的浪漫喜剧，甜度爆表！每一话都有精美的甜品插画，让人垂涎欲滴。',
    rating: 4.3,
    views: 467000,
    chapters: [
      { id: 'ch-11-1', title: '第1话 新邻居', updateDate: '2026-07-08', number: 1 },
      { id: 'ch-11-2', title: '第2话 甜点对决', updateDate: '2026-07-05', number: 2 },
      { id: 'ch-11-3', title: '第3话 意外合作', updateDate: '2026-07-02', number: 3 },
      { id: 'ch-11-4', title: '第4话 心跳加速', updateDate: '2026-06-29', number: 4 },
    ],
    tags: ['恋爱', '美食', '喜剧', '日常'],
    updateDate: '2026-07-08',
    status: '连载中',
    featured: false,
    hotRank: 11,
  },
  {
    id: 'comic-12',
    title: '深渊之眼',
    author: '沈俊昊',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20psychological%20thriller%20cover%2C%20haunted%20expression%20close-up%2C%20psychological%20horror%20atmosphere%2C%20dark%20moody%20digital%20illustration%2C%20distorted%20reality%20concept%2C%20clean%20simple%20background&width=600&height=800&seq=hanman-cover-12&orientation=portrait',
    category: 'mystery',
    description: '精神科医生金道允接诊了一位声称能看到"别人眼中的世界"的患者。随着治疗的深入，他发现患者的描述与一系列未解悬案惊人地吻合。当他试图揭开真相时，自己也陷入了现实与幻觉的边界。这是一部烧脑的心理悬疑漫画。',
    rating: 4.7,
    views: 389000,
    chapters: [
      { id: 'ch-12-1', title: '第1话 特殊患者', updateDate: '2026-06-25', number: 1 },
      { id: 'ch-12-2', title: '第2话 碎片记忆', updateDate: '2026-06-22', number: 2 },
      { id: 'ch-12-3', title: '第3话 连环', updateDate: '2026-06-19', number: 3 },
    ],
    tags: ['悬疑', '心理', '惊悚', '推理'],
    updateDate: '2026-06-25',
    status: '连载中',
    featured: false,
    hotRank: 12,
  },
];

export const aboutInfo = {
  brandName: '韩漫之家',
  slogan: '韩国漫画免费阅读首选平台',
  introduction: '韩漫之家成立于2020年，是国内领先的韩国漫画在线阅读平台。我们致力于为中国读者提供最新、最全、最高质量的韩国漫画资源。平台汇聚了数千部精品韩漫，涵盖恋爱、奇幻、动作、悬疑、日常、耽美等多个热门分类，满足不同读者的多样化阅读需求。',
  mission: '让每一位漫画爱好者都能轻松获取优质韩国漫画资源，享受流畅愉悦的阅读体验。',
  vision: '成为中文世界最受欢迎的韩国漫画阅读社区。',
  stats: [
    { label: '精品漫画', value: '5000+' },
    { label: '活跃用户', value: '200万+' },
    { label: '累计阅读', value: '10亿+' },
    { label: '合作作者', value: '300+' },
  ],
  features: [
    { title: '海量资源', description: '收录数千部优质韩国漫画，每日更新，品类齐全，总有你喜欢的作品。', icon: 'ri-stack-line' },
    { title: '流畅阅读', description: '采用先进的图片加载技术，翻页流畅，加载迅速，带来沉浸式阅读体验。', icon: 'ri-speed-up-line' },
    { title: '正版授权', description: '与多家韩国漫画出版社建立合作关系，确保内容正版合法，支持创作者。', icon: 'ri-shield-check-line' },
    { title: '社区互动', description: '读者可以在每部作品下讨论剧情、分享感受，找到志同道合的漫友。', icon: 'ri-chat-smile-2-line' },
  ],
  testimonials: [
    { name: '小雨', role: '资深漫迷', content: '韩漫之家是我每天必刷的平台！更新速度超快，分类也很全，从恋爱到悬疑每种类型都能找到喜欢的作品。界面阅读体验也非常流畅。', rating: 5 },
    { name: '星辰大海', role: '大学生', content: '作为韩漫爱好者，用过很多平台，韩漫之家是最让我满意的。画面清晰，加载快，还有收藏和追更功能，再也不用担心错过更新了！', rating: 5 },
    { name: '夜阑听风', role: '上班族', content: '工作之余最好的放松方式就是看漫画了，韩漫之家的分类做得很好，总能快速找到想看的类型。推荐给我身边所有喜欢看漫画的朋友。', rating: 4 },
    { name: '草莓奶昔', role: '漫画博主', content: '作为漫画博主，我对平台的要求比较高。韩漫之家的资源质量确实不错，正版授权让我推荐起来也很放心。期待更多优质作品上线！', rating: 5 },
  ],
  contact: {
    email: 'contact@hanmanzhijia.com',
    wechat: '韩漫之家官方',
    weibo: '@韩漫之家',
    address: '北京市朝阳区望京SOHO T1-1208',
    phone: '400-888-6688',
    workingHours: '周一至周五 9:00 - 18:00',
  },
  faqs: [
    { question: '韩漫之家的漫画都是免费的吗？', answer: '是的，韩漫之家平台上的所有漫画均提供免费在线阅读服务。我们通过广告和会员增值服务维持运营，确保基础阅读体验完全免费。' },
    { question: '如何第一时间知道喜欢的漫画更新了？', answer: '您可以在漫画详情页点击"收藏"按钮，收藏后该漫画更新时会自动出现在您的个人书架中，方便第一时间追更。' },
    { question: '韩漫之家的漫画资源来源是什么？', answer: '我们与多家韩国漫画出版社和作者建立了正式合作关系，所有上架作品均获得正版授权，确保内容的合法性和质量。' },
    { question: '支持手机阅读吗？', answer: '当然支持！韩漫之家采用响应式设计，完美适配手机、平板和电脑等多种设备。您可以在任何设备上享受流畅的阅读体验。' },
    { question: '如何联系客服？', answer: '您可以通过网站底部的"联系我们"板块找到客服邮箱、微信和电话等多种联系方式，我们的客服团队将在工作时间内尽快为您解答。' },
  ],
};

export function getComicsByCategory(categorySlug: string): ComicItem[] {
  if (categorySlug === 'all') return comics;
  return comics.filter((c) => c.category === categorySlug);
}

export function getComicById(id: string): ComicItem | undefined {
  return comics.find((c) => c.id === id);
}

export function getFeaturedComics(): ComicItem[] {
  return comics.filter((c) => c.featured);
}

export function getHotComics(limit: number = 10): ComicItem[] {
  return [...comics].sort((a, b) => a.hotRank - b.hotRank).slice(0, limit);
}

export function getRelatedComics(currentId: string, category: string, limit: number = 4): ComicItem[] {
  return comics.filter((c) => c.id !== currentId && c.category === category).slice(0, limit);
}